import React from 'react';
var Advertencia = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 9V14", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M5.94042 21.41C2.47042 21.41 1.02042 18.93 2.70042 15.9L5.82042 10.28L8.76042 5.00003C10.5404 1.79003 13.4604 1.79003 15.2404 5.00003L18.1804 10.29L21.3004 15.91C22.9804 18.94 21.5204 21.42 18.0604 21.42H12.0014V21.41H5.94042Z", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M11.9951 17H12.0041", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
Advertencia.defaultProps = {
    className: '',
};
export default Advertencia;
